/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import { NavLink } from "react-router-dom";

export const StyledNavLink = styled(NavLink)(({ color }) => ({
  textDecoration: "none",
  color: color || "#515152",
  fontSize: "13px",
  fontWeight: "400",
  "&.active": {
    color: "#2583e3",
  }
}));
